import React, { useCallback, useState, useEffect } from "react";
import { sendEmail } from "../utils/sendEmail";
import moment from "moment";
import { getInvoicesData } from "../api/finance-api";

const UnpaidEmail: React.FC = () => {
    const [unpaidList, setUnpaidList] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        async function fetchUnpaid() {
            setLoading(true);
            const filters = { 
                employee: "",
                yearLimit: false,
            };
            const data = await getInvoicesData(filters);
            
            const unpaid = data.filter((row: any) => {
                const invDate = moment(row._d);
                const minDate = moment("2025-01-01");
                if (invDate.isBefore(minDate, "day")) return false;
                
                if (!row.invoice_no) {
                    return row.bill > 0;
                }
                if (row.diff === undefined || !(row.diff > 0)) return false;
                return true;
            });
            setUnpaidList(unpaid);
            setLoading(false);
        }
        fetchUnpaid();
    }, []);

    const handleSendEmail = useCallback(async () => {
        if (loading) return;
        setSending(true);
        const htmlTable =
            unpaidList.length > 0
                ? `<table border="1" cellpadding="5" style="border-collapse:collapse;">
                        <thead><tr><th>Name</th><th>Invoice No</th><th>Project</th><th>Billing Period</th><th>Month</th><th style='text-align:right;'>Amount Due</th><th>Status</th><th>Invoice Date</th><th>Due Date</th></tr></thead>
                        <tbody>
                            ${unpaidList
                                .map((inv) => {
                                    const invDate = inv._ts_invoice ? moment(inv._ts_invoice).format("YYYY-MM-DD") : "-";
                                    const dueDate = inv._ts_invoice_due ? moment(inv._ts_invoice_due).format("YYYY-MM-DD") : "-";
                                    const status = inv.invoice_no ? (inv.diff > 0 ? "Unpaid" : "Paid") : "Not Generated";
                                    const amount = inv.invoice_no ? Number(inv.diff || 0) : Number(inv.bill || 0);
                                    return `<tr><td>${inv.name}</td><td>${inv.invoice_no || "-"}</td><td>${inv.project_name}</td><td>${inv.billing_period || '-'}</td><td>${inv.month1 ? `${inv.month1} ${inv.year}` : '-'}</td><td style='text-align:right;'>$ ${amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td><td>${status}</td><td>${invDate}</td><td>${dueDate}</td></tr>`;
                                })
                                .join("")}
                        </tbody>
                </table>
                <p><strong>Total Unpaid Amount: $ ${unpaidList.reduce((sum, inv) => sum + Number(inv.diff || inv.bill || 0), 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></p>`
                : "<p>No unpaid invoices.</p>";
        await sendEmail({
            to: ["accounts@mindtechinc.com"],
            subject: "Unpaid Invoice List",
            message: `<p>Here is the list of unpaid invoices (including non-generated invoices):</p>${htmlTable}`,
        });
        setSending(false);
    }, [unpaidList, loading]);

    return (
        <button onClick={handleSendEmail} disabled={sending || loading} className="px-6 py-2 text-white bg-orange-500 rounded hover:bg-orange-600 disabled:opacity-50">
            {loading ? "Loading..." : sending ? "Sending..." : "Send Unpaid Invoice List"}
        </button>
    );
};

export default UnpaidEmail;